class ValidarCpfCnpj {
  cpf(cpf, obrigadoriedadeCnpjCpf) {
    if (typeof cpf !== "string") return false;
    if (!obrigadoriedadeCnpjCpf && cpf === "") return true;
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) {
      return false;
    }
    cpf = cpf.split("");
    const validator = cpf
      .filter((digit, index, array) => index >= array.length - 2 && digit)
      .map((el) => +el);
    const toValidate = (pop) =>
      cpf
        .filter((digit, index, array) => index < array.length - pop && digit)
        .map((el) => +el);
    const rest = (count, pop) =>
      ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
        10) %
        11) %
      10;
    return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
  }

  cnpj(cnpj, obrigadoriedadeCnpjCpf) {
    if (typeof cnpj !== "string") return false;
    if (!obrigadoriedadeCnpjCpf && cnpj === "") return true;
    cnpj = normalizarCnpj(cnpj);
    if (!REGEX_CNPJ.test(cnpj)) return false;
    if (isExceptionCnpj(cnpj)) return false;
    const primeiraSoma = sumCnpjDigit(cnpj, 12);
    if (calculateRestCnpj(primeiraSoma) !== parseInt(cnpj.substring(12, 13), 10)) {
      return false;
    }
    const segundaSoma = sumCnpjDigit(cnpj.substring(0, 13), 13);
    if (calculateRestCnpj(segundaSoma) !== parseInt(cnpj.substring(13, 14), 10)) {
      return false;
    }
    return true;
  }
}

const REGEX_CNPJ = /^[A-Z0-9]{12}[0-9]{2}$/;
const VALOR_BASE_ASCII = "0".charCodeAt(0);

const normalizarCnpj = (value) =>
  value
    .replace(/[^A-Z0-9]/gi, "")
    .toUpperCase()
    .padStart(14, "0");

const isExceptionCnpj = (value) => {
  const lstCnpjException = [
    "00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999",
  ];
  return lstCnpjException.includes(value);
};

const sumCnpjDigit = (value, length) => {
  let pos = length - 7;
  let sumDigit = 0;
  for (let i = length; i >= 1; i--) {
    const valorPosicao = value.charCodeAt(length - i) - VALOR_BASE_ASCII;
    sumDigit += valorPosicao * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  return sumDigit;
};

const calculateRestCnpj = (value) => {
  return value % 11 < 2 ? 0 : 11 - (value % 11);
};

export default ValidarCpfCnpj;
